var FilterView = Backbone.View.extend({
  events: {
    "click [data-filter-reset]": "resetFilters",
    "click [data-filter-reset-key]": "resetFilterKey"
  },

  render: function(data) {
    this.isInitialized = true;

    this.$el.show();

    var noData = {};

    var selectedFilters = this.selectedFilters.search || {};

    if (data.vendors && data.vendors.length) {
      this.renderFilter(this.$("[data-filter-vendor]"), {
        isList: true,
        list: data.vendors,
        filterName: "vendor_ids",
        selected: selectedFilters.vendor_ids || []
      });
    } else {
      this.renderFilter(this.$("[data-filter-vendor]"), noData);
    }

    if (data.ships && data.ships.length) {
      this.renderFilter(this.$("[data-filter-ship]"), {
        isParentChildList: true,
        list: data.ships,
        filterName: "ship_ids",
        selected: selectedFilters.ship_ids || []
      });
    } else {
      this.renderFilter(this.$("[data-filter-ship]"), noData);
    }

    if (data.destinations && data.destinations.length) {
      this.renderFilter(this.$("[data-filter-destination]"), {
        isList: true,
        list: data.destinations,
        filterName: "destination_ids",
        selected: selectedFilters.destination_ids || []
      });
    } else {
      this.renderFilter(this.$("[data-filter-destination]"), noData);
    }

    if (data.departure_ports && data.departure_ports.length) {
      this.renderFilter(this.$("[data-filter-departure-port]"), {
        isList: true,
        list: data.departure_ports,
        filterName: "departure_port_ids",
        selected: selectedFilters.departure_port_ids || []
      });
    } else {
      this.renderFilter(this.$("[data-filter-departure-port]"), noData);
    }

    if (data.ports_of_call && data.ports_of_call.length) {
      this.renderFilter(this.$("[data-filter-port-of-call]"), {
        isList: true,
        list: data.ports_of_call,
        filterName: "port_of_call_ids",
        selected: selectedFilters.port_of_call_ids || []
      });
    } else {
      this.renderFilter(this.$("[data-filter-port-of-call]"), noData);
    }

    if (data.departure_months && data.departure_months.length) {
      this.renderFilter(this.$("[data-filter-departure-month]"), {
        isRadioGroupList: true,
        list: data.departure_months,
        filterName: "start_date",
        selected: selectedFilters.start_date || []
      });
    } else {
      this.renderFilter(this.$("[data-filter-departure-month]"), noData);
    }

    if (
      data.duration &&
      data.duration.min !== undefined &&
      data.duration.max !== undefined
    ) {
      const duration = {
        min: selectedFilters.duration_min,
        max: selectedFilters.duration_max
      };

      this.renderFilter(this.$("[data-filter-duration]"), {
        isRange: true,
        range: data.duration,
        filterName: "duration",
        selected: duration || {}
      });
    } else {
      this.renderFilter(this.$("[data-filter-duration]"), noData);
    }

    this.$el.loadComponents();
  },

  renderFilter: function(filterEl, data) {
    filterEl
      .show()
      .find("[data-filter-items]")
      .empty()
      .html(this.template(data))
      .removeClass("is-loading");
  },

  startFilterLoading: function() {
    this.$("[data-filter-items]").addClass("is-loading");
  },

  stopFilterLoading: function() {
    this.$("[data-filter-items]").removeClass("is-loading");
  },

  setSelectedFilters: function(selections) {
    this.selectedFilters = selections;
  },

  getSelectedFilters: function() {
    var el = this.$("[data-search-enhanced-filters]").clone();

    return $("<form></form>")
      .append(el)
      .serializeJSON();
  },

  /**
   * This method resets the filter fields
   *
   * @param key
   */
  resetFields: function(key) {
    var filterTypes = [
      "data-filter-field",
      "data-filter-check",
      "data-filter-radio",
      "data-filter-range"
    ];
    var x;

    for (x in filterTypes) {
      var resetKey = "";

      if (key) {
        // only reset a specific filter key if requested
        resetKey = "[" + filterTypes[x] + '="' + key + '"]';
      }

      // reset text inputs
      this.$('input[type="text"]' + resetKey).each(function(index, el) {
        $(el).val(null);
      });

      // reset radios and checkboxes
      this.$(
        'input[type="radio"]' + resetKey + ', input[type="checkbox"]' + resetKey
      ).each(function(index, el) {
        $(el).prop("checked", false);
      });

      // reset selects
      this.$("select" + resetKey).each(function(index, el) {
        $(el).val(null);
      });

      this.$("button" + resetKey).each(function(index, el) {
        $(el).removeClass("is-active");
      });

      // reset range sliders
      this.$('[data-component="range-slider"]' + resetKey).each(function(
        index,
        el
      ) {
        $(el)
          .component()
          .reset();
      });
    }
  },

  /**
   * This method resets the filters
   */
  resetFilters: function() {
    this.resetFields();
  },

  /**
   * This method resets a specific filter key
   *
   * @param event
   */
  resetFilterKey: function(event) {
    var key = $(event.currentTarget).data("filterResetKey");

    this.resetFields(key);
  },

  initialize: function(options) {
    this.isInitialized = false;
    this.selectedFilters = { search: {} };
    this.stateModel = options.stateModel;

    this.template = Handlebars.compile(
      this.$("[data-filters-template]").length
        ? this.$("[data-filters-template]").html()
        : ""
    );
  }
});

module.exports = FilterView;
